// Exporting a function named `getter` that acts as a custom getter for a Proxy object.
export const getter = (target, property) => {
  // Initializing `value` with the default property value from the target object.
  let value = target.default

  // Iterating over all keys in the target object.
  Object.keys(target).forEach((key) => {
    // Using a regular expression to match the requested property against the keys of the target object.
    // If a match is found, updating `value` with the corresponding value from the target object.
    if (new RegExp(key).test(property)) value = target[key]
  })

  // Returning the final value determined by the matching process.
  return value
}
